<template>
    <div class="page naxin">
        <img class="top-img" :src="study_group.main_img" alt/>

        <div class="page-container">
            <div class="position" v-for="item in study_group.configure">
                <div class="position-name">
                    <img class="title-img" src="/static/img/naxin/icon_expert_title.svg" alt />
                    <div>{{ item.name }} <span class="desc">{{id=='17'?'':'专家排序按照拼音姓氏排序'}}</span></div>
                </div>
                <div class="staff">
                    <div :class="study_group.show_avatar == 1 && val.avatar != '' ? 'staff-box' : 'staff-box no-avatar'" v-for="val in item.members" @click="handleInfo(val)">
                        <img class="avatar" v-if="study_group.show_avatar == 1 && val.avatar != ''" :src="val.avatar" alt />
                        <div class="name">{{ val.name }}</div>
                        <div class="hospital">{{ val.hospital }}</div>
                    </div>
                </div>
            </div>
            <div class="global-back">
                <img src="/static/third/detail_back_btn.svg" @click="$router.back()" alt="">
            </div>
            <!-- 遮罩层 -->
            <van-dialog class="group_rec" v-model="show" :showConfirmButton="false">
                <div class="wrapper" @click.stop>
                    <div class="block">
                        <img src="/static/img/naxin/icon_expert_popup_tag.svg" alt />
                        <div class="info-top">
                            <img v-if="item.avatar != ''" class="dialog-avatar" :src="item.avatar" alt />
                            <div class="title">
                                <div class="name">{{ item.name }}</div>
                                <div class="office">{{ item.hospital }}</div>
                            </div>
                        </div>
                        <div class="dia-content">
                            <span v-html="item.desc"></span>
                            <br><br>
                        </div>
                    </div>
                </div>
                <div class="close">
                    <img
                        @click="handleClose"
                        class="close-img"
                        src="/static/img/naxin/icon_popup_close.svg"
                        alt
                    />
                </div>
            </van-dialog>
        </div>


    </div>
</template>

<script>
import Interface from "@/util/interface"
export default {
    data () {
        return {
            id:0,
            topic:{
                footer_img:""
            },
            study_group:{},
            show: false,
            item:{},
            avatarImg: 'https://img0.baidu.com/it/u=348766424,581681588&fm=253&fmt=auto&app=138&f=JPEG?w=500&h=500'
        }
    },
    methods: {
        async handleInfo (item) {
            this.item = item
            await this.fetch('detail')
        },
        handleClose () {
            this.show = false
        },
        fetchTopic() {
            Interface.getData('get', Interface.topic.detail + this.$route.params.topic_id).then((res) => {
                this.topic = res.data

                let title = ""
                this.topic.modules.forEach(val=>{
                    if(val.id == this.$route.params.topic_subject_id){
                        title += val.title
                    }
                })
                let desc = ""
                switch (this.topic.id) {
                    case 2:
                        desc = "一站式解锁诊断技术发展动态，行业专家亲身传授，与数万名同道共成长"
                        break
                    case 4:
                        desc = "把脉国际学术新知"
                        break
                    default:
                        desc = this.topic.desc
                        break
                }

                Interface.getShareInfo(this, this.topic.title+"-"+title, this.topic.cover_img, desc)
            })
        },
        fetch(scene) {
            if(scene == 'study_group'){
                Interface.getData('get',Interface.topic.study_group_list,{meeting_subject_id:this.id}).then(val=>{
                    if(val.data.list && val.data.list.length > 0){
                        Interface.getData('get', Interface.topic.study_group+val.data.list[0].id).then((res) => {
                            this.study_group = res.data
                        })
                    }
                })
            }else if(scene == 'detail'){
                Interface.getData('get', Interface.topic.study_group_member+this.item.id).then((res) => {
                    this.item = res.data
                    if(res.data.desc.length > 2){
                        this.show = true
                    }
                })
            }
        },
    },
    created() {
        this.fetchTopic()
        this.id = this.$route.params.topic_id
        this.fetch('study_group')
    },
}
</script>

<style lang="scss">
@import './index.scss';
</style>



// WEBPACK FOOTER //
// src/views/topic/study-group-recruitment/index.vue